const TheContainer = () => import("@/containers/TheContainer.vue");
const ListRefund = () => import("@/domain/refund/ListRefund.vue");
const NewRefund = () => import("@/domain/refund/NewRefund.vue");
const RefundDetail = () => import("@/domain/refund/RefundDetail.vue");

export default [
    {
        path: '/refund',
        name: 'refund',
        component: TheContainer,
        meta: {perms: ['menu.refunds']},
        children: [
            {
                path: 'list',
                name: 'refund.list',
                component: ListRefund,
                meta: {label: 'List Order Item Refund',},
            },
            {
                path: 'new',
                name: 'refund.new',
                component: NewRefund,
                meta: {label: 'Create new Refund',},
            },
            {
                path: ':id',
                name: 'refund.detail',
                component: RefundDetail,
                meta: {label: 'Show Refund',},
            },
        ]
    }
]